import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { QueryOptions } from '../../../../../../types/query/useQuery';
import { UserGradeSummaryResponseType } from '../types';
import { USER_GRADE_QUERY_KEYS } from './queryKeys';
import { GetUserGradeSummaryUsecaseImpl } from '../usecases/GetUserGradeSummaryUsecase';
import { UserGradeSummaryRepository } from '../repositories/UserGradeSummaryRepository';

type UseUserGradeSummaryQueryArgs<SelectReturnType> = {
  userId: number;
  options: QueryOptions<UserGradeSummaryResponseType, unknown, SelectReturnType>;
};
export const useUserGradeSummaryQuery = <SelectReturnType>({
  userId,
  options,
}: UseUserGradeSummaryQueryArgs<SelectReturnType>): UseQueryResult<SelectReturnType, unknown> => {
  const getUserGradeSummaryUsecase = new GetUserGradeSummaryUsecaseImpl(UserGradeSummaryRepository);
  return useQuery<UserGradeSummaryResponseType, unknown, SelectReturnType>(
    USER_GRADE_QUERY_KEYS.SUMMARY,
    () => getUserGradeSummaryUsecase.invoke(userId),
    { ...options },
  );
};
